import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import TalentMediaRender from './TalentMedia.render';
import {useLazyQuery} from '@apollo/client';
import {query} from '../../../actions/queries';

export default function TalentMediaLoad():JSX.Element{
	const {id}:any = useParams();

	const [loading, setLoading] = useState<boolean>(true);
	// eslint-disable-next-line @typescript-eslint/typedef
	const [getData, { data }] = useLazyQuery(query('talentMediaFindMany'));

	useEffect(():void=>{
		if(loading){
			getData({
				variables: {
					filter: {
						user: id
					},
					limit: 15
				},
				fetchPolicy: 'no-cache',
				onCompleted: (data:any):void => setLoading(false)
			});
		}
	},[loading]);

	return (
		<TalentMediaRender media={data?.talentMediaFindMany} />
	);
}